import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "table table-condensed m-0"
};
const _hoisted_2 = {
  key: 0,
  class: "border-top-0"
};
const _hoisted_3 = {
  class: "text-end text-success align-middle border-top-0 fw-bold"
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "text-end text-success align-middle fw-bold"
};
const _hoisted_6 = {
  key: 2
};
const _hoisted_7 = {
  class: "text-end text-success align-middle fw-bold"
};
const _hoisted_8 = {
  class: "text-end align-middle fw-bold"
};
const _hoisted_9 = {
  key: 3
};
const _hoisted_10 = {
  class: "text-end text-warning align-middle fw-bold"
};
const _hoisted_11 = {
  class: "text-end text-warning align-middle fw-bold"
};
const _hoisted_12 = {
  key: 4,
  class: "success"
};
const _hoisted_13 = {
  class: "text-end align-middle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_card_header = _resolveComponent("b-card-header");
  const _component_Loading = _resolveComponent("Loading");
  const _component_b_card_body = _resolveComponent("b-card-body");
  const _component_b_card = _resolveComponent("b-card");
  return $props.subscription && ($props.subscription.credit > 0 || $props.subscription.remainingvalue > 0) ? (_openBlock(), _createBlock(_component_b_card, {
    key: 0,
    "no-body": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_b_card_header, {
      class: "m-0"
    }, {
      default: _withCtx(() => [_cache[0] || (_cache[0] = _createTextVNode(" Payment Breakdown: ", -1)), _withDirectives(_createElementVNode("small", null, "* breakdown shown in USD to reflect the actual charges to be made", 512), [[_vShow, $props.subscription.localcredit.localcurrency !== 'USD']])], undefined, true),
      _: 1
    }), _createVNode(_component_b_card_body, {
      class: "p-0"
    }, {
      default: _withCtx(() => [_createVNode(_component_Loading, {
        loading: $props.loading
      }, null, 8, ["loading"]), _withDirectives(_createElementVNode("table", _hoisted_1, [_cache[9] || (_cache[9] = _createElementVNode("colgroup", null, [_createElementVNode("col"), _createElementVNode("col", {
        width: "0*"
      })], -1)), _createElementVNode("tbody", null, [$props.subscription.remainingvalue > 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("td", {
        class: "text-end border-top-0"
      }, [_createTextVNode(" Value remaining in current subscription:"), _createElementVNode("br"), _createElementVNode("small", null, "(Pro-rated off current subscription age and amount)")], -1)), _createElementVNode("td", _hoisted_3, _toDisplayString($props.subscription.localremainingvalue.localcurrencyformatted), 1)])) : _createCommentVNode("", true), $props.subscription.existingCredit > 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("td", {
        class: "text-end"
      }, "Account Credit:", -1)), _createElementVNode("td", _hoisted_5, _toDisplayString($props.subscription.localexistingCredit.localcurrencyformatted), 1)])) : _createCommentVNode("", true), $props.subscription.remainingValue > 0 && $props.subscription.existingCredit > 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [_cache[3] || (_cache[3] = _createElementVNode("td", {
        class: "text-end"
      }, "Total Credit", -1)), _createElementVNode("td", _hoisted_7, _toDisplayString($props.subscription.localcredit.localcurrencyformatted), 1)])) : _createCommentVNode("", true), _createElementVNode("tr", null, [_cache[4] || (_cache[4] = _createElementVNode("td", {
        class: "text-end"
      }, "New Subscription Amount:", -1)), _createElementVNode("td", _hoisted_8, _toDisplayString($props.subscription.localamount.localcurrencyformatted), 1)]), $props.discount && $props.discount.amount > 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [_cache[5] || (_cache[5] = _createElementVNode("td", {
        class: "text-end"
      }, "Discount Applied:", -1)), _createElementVNode("td", _hoisted_10, " (" + _toDisplayString($props.discount.localcurrencyformatted) + ") ", 1)])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("tr", null, [_cache[6] || (_cache[6] = _createElementVNode("td", {
        class: "text-end"
      }, "Credit Applied:", -1)), _createElementVNode("td", _hoisted_11, " (" + _toDisplayString($props.subscription.localappliedCredit.localcurrencyformatted) + ") ", 1)], 512), [[_vShow, $props.subscription.appliedCredit > 0]]), _createElementVNode("tr", null, [_cache[7] || (_cache[7] = _createElementVNode("td", {
        class: "text-end"
      }, "Balance Due:", -1)), _createElementVNode("td", {
        class: _normalizeClass(["text-end align-middle fw-bold", $props.subscription.billingamount > 0 ? 'text-danger' : ''])
      }, _toDisplayString($props.subscription.localbillingamount.localcurrencyformatted), 3)]), $props.subscription.remainingCredit > 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [_cache[8] || (_cache[8] = _createElementVNode("td", {
        class: "text-end"
      }, [_createTextVNode(" Credit left over:"), _createElementVNode("br"), _createElementVNode("small", null, "(This amount will be applied to the next billing cycle until depleted)")], -1)), _createElementVNode("td", _hoisted_13, _toDisplayString($props.subscription.localremainingCredit.localcurrencyformatted), 1)])) : _createCommentVNode("", true)])], 512), [[_vShow, !$props.loading]])], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true);
}